import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LazyImageDirective } from '../../../../../../../../directive/lazyImage.directive';
import { CompatibilityCardComponent } from '../../../shared/compatibility-card/compatibility-card.component';

@Component({
    selector: 'app-optical-sensor-tutorial',
    templateUrl: './optical-sensor-tutorial.component.html',
    styleUrls: ['./optical-sensor-tutorial.component.scss'],
    standalone: true,
    imports: [
        CompatibilityCardComponent,
        LazyImageDirective,
        TranslateModule,
    ],
})
export class OpticalSensorTutorialComponent {}
